import { LoginForm } from "../../components/common/auth/loginForm";
import { ConstellationBackground } from "../../components/common/layout/constellationBackground";

export const LoginPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-global-page relative isolate">
      <ConstellationBackground />
      <div className="flex-1 flex items-center justify-center px-3 sm:px-4 py-6 sm:py-8">
        <LoginForm />
      </div>
    </div>
  );
};
